module.exports = __webpack_public_path__ + "static/media/bg_plan_suggestion_over_50.bc60a6a1.webp";